import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';

import { AuthenticationService, UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { CartModel } from './../../../models';
import { StepIndicatorService, PageLoaderService } from 'lib/ng2-sapmp/src/ui-components';
import { ANALYTICS_CONSTANTS } from 'config';
import { HeaderService } from './../../header/header.service';


declare var ENV_PORTAL;

@Component({
  selector: 'app-checkout-order-confirm',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./../checkout.component.scss']

})
export class OrderConfirmationComponent implements OnInit {
  confirmedOrder: CartModel = null;
  billNumber: string;
  tnctitle: string;

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private stepindicatorService: StepIndicatorService, private authenticationService: AuthenticationService,
    private utilityService: UtilityService, private pageLoaderService: PageLoaderService,
    private adobeAnalyticsService: AdobeAnalyticsService, private headerService: HeaderService) {
  }

  ngOnInit() {
    this.headerService.setCondensedFooterStatus(false);
    this.headerService.condensedHeader('confirmOrder');

    if (sessionStorage.getItem('cart-order') === null) {
      this.router.navigate(['/home']);
      return;
    }
    this.pageLoaderService.setPageLoaderStatus(false);
    if (ENV_PORTAL === 'fnabc') {
      this.tnctitle = 'FirstNet Terms of Service';
    } else {
      this.tnctitle = 'ABC Terms of Service';
    }
    // document.title = 'AT&T Business Console - Checkout - Order Confirmation';
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);
    this.stepindicatorService.setVisibility(true);
    this.confirmedOrder = Object.create(JSON.parse(sessionStorage.getItem('cart-order')));
    this.billNumber = this.utilityService.formatTelephoneNumber(this.confirmedOrder.ctn);
    this.createPageLoadProperties(this.confirmedOrder, this.router.routerState.snapshot.url,
      'Checkout confirm order', 'BC Checkout Confirm Order Pg');
    this.pageLoaderService.setPageLoaderStatus(true);
  }

  private createPageLoadProperties(order, url, pageTitle, friendlyPageName) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_CHECKOUT_STEP4;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_CHECKOUT;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    if (order) {
      let sku;
      for (const lineItem of order.lineItems) {
        sku = (sku === undefined) ? lineItem.sku.socCode : sku + '|' + lineItem.sku.socCode;
      }
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SKU] = sku;
    }
    if (order.ban) {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_BAN] = order.ban; // BAN
    }
    if (order.ctn) {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_CTN] = order.ctn; // CTN
    }
    if (ENV_PORTAL === 'fnabc') {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FIRSTNET_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_1;
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FIRST_NET_USER_ROLE] = ANALYTICS_CONSTANTS.GLOBAL_USER_FIRST_NET_USER_ROLE_VALUE;
    }
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Sales';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_ABS_CHECKOUT_STEP] = pageTitle;
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }
  continueshopping() {
    sessionStorage.removeItem('cart-order');
    this.stepindicatorService.removeStep('checkout');
    this.router.navigate(['home']);
  }
}

